export default "__VITE_ASSET__ab24ff04__"